export const TimesheetChangeType = Object.freeze({
  /**
   * Describes a change to either the start or end time of a booking from the original time.
   * e.g. Original booking: 09:30 - 15:30. Candidate changes: 09:00 - 15:30. The delta would be +30 mins.
   */
  delta: 'delta',
  /**
   * Describes a change to the start and end time of a booking that shifts the time frame of the booking forward or backwards.
   * e.g. Original booking: 09:30 - 15:30. Candidate changes: 10:30 - 16:30. The shift would be 1 hr.
   */
  shift: 'shift',
  /**
   * Describes a change to the unpaid breaks.
   */
  unpaidBreaks: 'unpaidBreaks',
})
